import { useEffect, useRef, useState } from "react";
import Configuraciones from "../../page/configuraciones/Configuraciones"
import apiPrivateAntesala from "../../../config/ConfigPrivate";

const ConfiguracionesController = () => {
    const [banners, setBanners] = useState(null);
    const [categorias, setCategorias] = useState(null);
    const [categoriasNotas, setCategoriasNotas] = useState(null);
    const [provincias, setProvincias] = useState(null);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState({
        per_page: 1000,
        ["filter[stated]"]: "ACTIVO",
        sort: "-id",
    });
    const [modal, setModal] = useState({
        banner: {
            status: false,
            data: null
        }
    });
    const [form, setForm] = useState({
        nombre: ["", ""],
        imagen: [null, ""],
        provincia: ["", ""],
        posicion: ["", ""],
        vigencia_desde: ["", ""],
        vigencia_hasta: ["", ""],
        stated: ["ACTIVO", ""]
    });
    const controllerRef = useRef(null);

    const fetch = async (setData, params, url, signal, loading) => {
        try {
            const response = await apiPrivateAntesala.get(url, {
                params,
                signal,
            });
            if (response.status == 201 || response.status == 200) {
                setData(response.data);
                if (loading) {
                    loading(false);
                }
            }
        } catch (error) {
            if (error.name === "AbortError") {
                console.log("Request aborted");
            } else {
                console.error("Error fetching data:", error);
            }
        }
    };

    useEffect(() => {
        if (!banners) {
            setLoading(true);
            let params = {
                ...filter,
            };
            fetch(setBanners, params, "/banners", null, setLoading);
        }
    }, []);

    useEffect(() => {
        if (!categorias) {
            setLoading(true);
            let params = {};
            fetch(setCategorias, params, "/categorias", null, setLoading);
        }
    }, []);

    useEffect(() => {
        if (!categoriasNotas) {
            setLoading(true);
            let params = {};
            fetch(setCategoriasNotas, params, "/categorias-nota", null, setLoading);
        }
    }, []);

    useEffect(() => {
        if (!provincias) {
            setLoading(true);
            let params = {
                list: true
            };
            fetch(setProvincias, params, "/provincias", null, setLoading);
        }
    }, []);

    const onClick = async (e, value) => {
        switch (e.target.name) {
            case "nuevo_banner":
                setModal({
                    ...modal,
                    banner: {
                        status: true,
                        data: null
                    }
                });
                break;
            case "editar_banner":
                {
                    // Buscar el banner por ID
                    const banner = banners?.data.find(b => b.id === value);
                    if (banner) {
                        const vigencia = banner.vigencia ? JSON.parse(banner.vigencia) : ["", ""];
                        setForm({
                            id: [banner.id, ""],
                            nombre: [banner.nombre || "", ""],
                            imagen: [null, ""],
                            imagen_actual: [banner.imagen || "", ""],
                            provincia: [banner.provincia || "", ""],
                            posicion: [banner.posicion || "", ""],
                            vigencia_desde: [vigencia[0] || "", ""],
                            vigencia_hasta: [vigencia[1] || "", ""],
                            stated: [banner.stated || "ACTIVO", ""]
                        });
                        setModal({
                            ...modal,
                            banner: {
                                status: true,
                                data: banner.id
                            }
                        });
                    }
                }
                break;
            case "cerrar_modal":
                setModal({
                    ...modal,
                    banner: {
                        status: false,
                        data: null
                    }
                });
                setForm({
                    nombre: ["", ""],
                    imagen: [null, ""],
                    provincia: ["", ""],
                    posicion: ["", ""],
                    vigencia_desde: ["", ""],
                    vigencia_hasta: ["", ""],
                    stated: ["ACTIVO", ""]
                });
                break;
            case "guardar_banner":
                setLoading(true);
                try {
                    const formData = new FormData();
                    formData.append("nombre", form.nombre[0]);
                    formData.append("provincia", form.provincia[0]);
                    formData.append("posicion", form.posicion[0]);
                    formData.append("vigencia", JSON.stringify([form.vigencia_desde[0], form.vigencia_hasta[0]]));
                    formData.append("stated", form.stated[0]);

                    // Solo agregar imagen si se seleccionó una nueva
                    if (form.imagen[0]) {
                        formData.append("imagen", form.imagen[0]);
                    }

                    let response;
                    if (modal.banner.data) {
                        // Editar banner existente
                        formData.append("_method", "PUT");
                        formData.append("id", modal.banner.data);
                        response = await apiPrivateAntesala.post(`/banners`, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                    } else {
                        // Crear nuevo banner
                        response = await apiPrivateAntesala.post("/banners", formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                    }

                    if (response.status === 201 || response.status === 200) {
                        // Recargar banners
                        let params = { ...filter };
                        fetch(setBanners, params, "/banners", null, null);

                        // Cerrar modal
                        setModal({
                            ...modal,
                            banner: {
                                status: false,
                                data: null
                            }
                        });

                        // Limpiar form
                        setForm({
                            nombre: ["", ""],
                            imagen: [null, ""],
                            provincia: ["", ""],
                            posicion: ["", ""],
                            vigencia_desde: ["", ""],
                            vigencia_hasta: ["", ""],
                            stated: ["ACTIVO", ""]
                        });
                    }
                } catch (error) {
                    console.error("Error al guardar banner:", error);
                } finally {
                    setLoading(false);
                }
                break;
        }
    }

    const onChange = (e, value) => {
        const name = e.target.name;
        const val = e.target.type === 'file' ? e.target.files[0] : e.target.value;

        setForm({
            ...form,
            [name]: [val, ""]
        });
    }

    if(!categoriasNotas || !categorias || !banners){
        return ""
    }

    return <Configuraciones
        provincias={provincias}
        banners={banners}
        categorias={categorias}
        categoriasNotas={categoriasNotas}
        loading={loading}
        onClick={onClick}
        onChange={onChange}
        setFilter={setFilter}
        filter={filter}
        modal={modal}
        form={form}

        setBanners={setBanners}
        setCategorias={setCategorias}
        setCategoriasNotas={setCategoriasNotas}
    />
}

export default ConfiguracionesController